<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>对账明细</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="20">
                  <el-input
                      placeholder="请输入查询内容"
                      clearable
                      v-model="queryInfo.query"
                      style="width: 300px"
                  >
                    <el-select
                        slot="prepend"
                        v-model="queryInfo.queryType"
                        placeholder="选择"
                        style="width: 110px"
                    >
                      <el-option label="用户名" value="username"></el-option>
                      <el-option label="卡名" value="cardname"></el-option>
                      <el-option label="订单编号" value="orderno"></el-option>
                    </el-select>
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                    ></el-button>
                  </el-input>
                  <el-select
                      v-model="queryInfo.query2"
                      clearable
                      placeholder="请选择交易类型"
                      style="width: 150px;margin-left:10px"
                  >
                    <el-option label="平台" value="0"></el-option>
                    <el-option label="抖音" value="1"></el-option>
                    <el-option label="美团" value="2"></el-option>
                    <el-option label="高德" value="7"></el-option>
                    <el-option label="赠送" value="3"></el-option>
                    <el-option label="分享" value="4"></el-option>
                    <el-option label="异业" value="5"></el-option>
                    <el-option label="复制" value="6"></el-option>
                  </el-select>
                  <el-select
                      v-model="queryInfo.orderType"
                      clearable
                      placeholder="请选择订单类型"
                      style="width: 150px;margin-left:10px"
                  >
                    <el-option label="购卡订单" value="0"></el-option>
                    <el-option label="助教订单" value="1"></el-option>
                    <el-option label="支付退款订单" value="2"></el-option>
                    <el-option label="停卡订单" value="3"></el-option>
                    <el-option label="带帐发卡订单" value="4"></el-option>
                  </el-select>
                    <el-select v-model="queryInfo.query1"  placeholder="请选择门店" style="margin-left:10px" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-date-picker
                        v-model="customdate"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="CustomeDate"
                        style="margin: 0 10px"
                        :clearable="false">
                    </el-date-picker>
                    <el-select  v-model="queryInfo.zxFlag" clearable  placeholder="是否退款" style="margin: 0 10px;width:150px">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="退款" value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" style="text-align: right;">
<!--                    <download-excel :data = "exclelist" :fields = "excel_fields" name = "财务对帐明细">-->
<!--                        <el-button type="primary" icon="el-icon-upload" @click="CheckDate" v-permission="'btn:finance:checkdetail:export'">导出Excel</el-button>-->
<!--                    </download-excel>-->
                  <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="isLoading">搜索</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="CheckDate" :loading="exporting" v-permission="'btn:finance:checkdetail:export'">导出Excel</el-button>
                </el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="orderlist" style="width: 100%" ref="invoiceTable" stripe size="small" height="660" v-loading="isLoading">
                <el-table-column label="序号" width="50" fixed>
                    <template slot-scope="scope">
                        {{ (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="订单编号" prop="orderno" width="140"></el-table-column>
              <el-table-column label="订单类型" prop="orderType" width="120">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.orderType == '0'">购卡订单</el-tag>
                  <el-tag type="danger" v-else-if="scope.row.orderType == '1'">助教订单</el-tag>
                  <el-tag type="warning" v-else-if="scope.row.orderType == '2'">支付退款订单</el-tag>
                  <el-tag type="info" v-else-if="scope.row.orderType == '3'">停卡订单</el-tag>
                  <el-tag type="primary" v-else-if="scope.row.orderType == '4'">带帐发卡订单</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="订单状态" prop="istuikuan" width="100">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.istuikuan == '0'">正常</el-tag>
                  <el-tag type="danger" v-else-if="scope.row.istuikuan == '1'">退款</el-tag>
                </template>
              </el-table-column>
                <el-table-column label="用户名" prop="username" width="100"></el-table-column>
                <el-table-column label="店铺名" prop="storename" width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="卡名" prop="cardname" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="display: flex;" v-if="scope.row.cardname">
                            <div style="padding-right: 5px;line-height: 30px;">
                                {{ scope.row.cardname }}
                            </div>
                            <div>
                                <el-tag type="danger" v-if="scope.row.istuikuan == '1'">退款</el-tag>
                            </div>
                        </div>
                      <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="金额" prop="amount" width="100">
                    <template slot-scope="scope" v-if="scope.row.amount">
                        <span style="color: #ff0000;">￥{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="退款金额"
                    prop="refundamount"
                    width="100"
                >
                  <template slot-scope="scope">
                    <span style="color: #1989fa" v-if="scope.row.refundamount">￥{{ scope.row.refundamount }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="总部扣点" prop="pointsamount" width="100">
                    <template slot-scope="scope" v-if="scope.row.pointsamount">
                        <span style="color: #34c617;">￥{{scope.row.pointsamount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="抖音扣点" prop="dypointspamount" width="100">
                    <template slot-scope="scope">
                        <span style="color: #34c617;" v-if="scope.row.amount && scope.row.cardfrom == '1'">￥{{ Math.round(scope.row.amount * 0.05 * 100) / 100 }}</span>
                      <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="美团扣点" prop="mtpointspamount" width="100">
                    <template slot-scope="scope">
                        <span style="color: #34c617;" v-if="scope.row.amount && scope.row.cardfrom == '2'">￥{{ Math.round(scope.row.amount * 0.07 * 100) / 100 }}</span>
                      <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="门店结算" prop="storeowneramount" width="100">
                    <template slot-scope="scope" v-if="scope.row">
                        <span style="color: #34c617;">{{ calculateOwnerAmount(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="来源" prop="cardfrom" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.cardfrom == '0'">平台</el-tag>
                        <el-tag type="danger" v-if="scope.row.cardfrom == '1'">抖音</el-tag>
                        <el-tag type="warning" v-if="scope.row.cardfrom == '2'">美团</el-tag>
                        <el-tag v-if="scope.row.cardfrom == '7'">高德</el-tag>
                        <span v-if="scope.row.cardfrom == '1' || scope.row.cardfrom == '2' || scope.row.cardfrom == '7'" style="padding-left: 10px;">劵码：{{ scope.row.extra }}</span>
                        <el-tag type="primary" v-if="scope.row.cardfrom == '3'">赠送</el-tag>
                        <el-tag type="info" v-if="scope.row.cardfrom == '4'">分享</el-tag>
                        <el-tag type="info" v-if="scope.row.cardfrom == '5'" effect="dark">异业</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="收款商户" prop="mchid" width="100"></el-table-column>
                <el-table-column
                    label="退款状态"
                    width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.istuikuan == 1">
                      <el-tag
                          type="danger"
                      >已退款</el-tag>
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="订单日期" prop="adddate" width="150" fixed="right"></el-table-column>
                <el-table-column label="退款日期" prop="refundDateStr" width="150" fixed="right"></el-table-column>
                <el-table-column
                    label="分账状态"
                    width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.fzStatus == 'PROCESSING' || scope.row.fzStatus == 'PENDING_RETRY' || scope.row.fzStatus == 'RELOAD'">
                      <el-tag
                          type="primary"
                      >分账中</el-tag>
                    </span>
                          <span v-else-if="scope.row.fzStatus == 'ERROR' || scope.row.fzStatus == 'ERROR_JD' || scope.row.fzStatus == 'JD_ERROR'">
                      <el-tag
                          type="danger"
                      >分账失败</el-tag>
                    </span>
                          <span v-else-if="scope.row.fzStatus == 'FINISHED'">
                      <el-tag
                          type="success"
                      >分账成功</el-tag>
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="分账失败原因"
                    min-width="150"
                    :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.fzStatus == 'ERROR' || scope.row.fzStatus == 'ERROR_JD' || scope.row.fzStatus == 'JD_ERROR'">
                      {{scope.row.fzError}}
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                  <!-- 游标分页提示 -->
                  <div v-if="useCursorPaging && hasMore" style="margin-bottom: 10px; color: #409EFF;">
                      <i class="el-icon-info"></i> 使用游标分页，性能更优
                  </div>
                  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,100,200]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
import {Loading} from "element-ui";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
    data(){
        return{
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            exporting: false,
            customdate: [],
            //获取订单列表的参数对象
            queryInfo: {
              query: '',
              query1: '',
              storeName: '',
              query2: '',
              orderType: '',
              queryType: 'username',
              startdate: '',
              enddate: '',
              zxFlag: null,
              pagesize: 20,
              pagenum: 1
            },
            orderlist: [],
            storelist:[],
            total: 0,
            loading: false,
            isLoading:false,
            hasMore: false, // 是否还有更多数据
            useCursorPaging: false // 是否使用游标分页（默认传统分页兼容旧版）
        }
    },
    created() {
         // 默认选择今天日期
         const today = new Date();
         const todayStr = this.formatDate(today);
         this.customdate = [todayStr, todayStr];
         this.queryInfo.startdate = todayStr;
         this.queryInfo.enddate = todayStr;

         this.getOrderList()
         this.GetStore()
    },
    methods:{
        // 格式化日期为 yyyy-MM-dd
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        async GetStore(){
            const { data: res } = await this.$http.get('store/')
            if(res.status == 0){
                this.storelist = res.data
            }
       },
        async getOrderList() {
          this.isLoading = true;
           // 验证时间参数是否为空
           if (!this.queryInfo.startdate || !this.queryInfo.enddate) {
               this.$message.error('请选择查询时间范围');
               this.isLoading = false;
               return;
           }

           // 统一使用游标分页和视图查询
           const params = { ...this.queryInfo };

           const { data: res} = await this.$http.get('dzOrderList/',{ params })
           if(res.status == 1){
                if (res.data.count) {
                  this.total = res.data.count;
                }

                this.orderlist = res.data.list.map(v => {
                    return v.fields
                })

                for (let index = 0; index < res.data.list.length; index++) {
                    this.orderlist[index].id= res.data.list[index].pk;
                }
            } else {
                this.$message.error(res.message || '查询失败');
            }
            this.isLoading = false
       },
      handleSearch() {
        this.queryInfo.pagenum = 1
        this.getOrderList()
      },
        handleSizeChange(newSize){
           this.queryInfo.pagesize = newSize
           // 重置游标和页码
           this.queryInfo.pagenum = 1
           this.getOrderList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pagenum = newPage
           this.getOrderList()
       },
        CustomeDate(){
            if(this.customdate == null || this.customdate.length === 0){
                this.$message.warning('请选择查询时间范围');
                // 重置为今天
                const today = new Date();
                const todayStr = this.formatDate(today);
                this.customdate = [todayStr, todayStr];
                this.queryInfo.startdate = todayStr;
                this.queryInfo.enddate = todayStr;
                return;
            }else{
                this.queryInfo.startdate = this.customdate[0]
                this.queryInfo.enddate = this.customdate[1]
            }
        },
      CheckDate(){
        if (!this.customdate || this.customdate.length === 0) {
          this.$message.error('请先选择日期范围')
          return
        }
        this.exporting = true
        let downloadLoadingInstance = Loading.service({
          text: "正在下载数据，请稍候",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axios
            .get("/orderAllDzList/export", {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              responseType: "blob",
              params: this.queryInfo,
            })
            .then(async (data) => {
              this.exporting = false;
              const isBlob = data.data.type !== "application/json";
              if (isBlob) {
                const blob = new Blob([data.data]);
                saveAs(blob, `结算数据_${new Date().getTime()}.xlsx`);
              } else {
                const text = await data.data.text();
                const json = JSON.parse(text);
                this.$message.error(json.message || "导出结算数据失败");
              }
              downloadLoadingInstance.close();
            })
            .catch(async (r) => {
              this.exporting = false;
              console.error(r);
              if (r.response && r.response.data) {
                const text = await r.response.data.text();
                const json = JSON.parse(text);
                this.$message.error(json.message || "下载文件出现错误");
              } else {
                this.$message.error("下载文件出现错误，请联系管理员！");
              }
              downloadLoadingInstance.close();
            });
      },
        calculateOwnerAmount(row) {
          if (row.owneramount) {
            return row.owneramount;
          }

            const amount = parseFloat(row.amount) || 0;
            const pointsamount = parseFloat(row.pointsamount) || 0;

            let deduction = 0;
            var owneramount = "￥0.00"
            if (row.cardfrom == '1') {
                deduction = Math.round(amount * 0.05 * 100) / 100;
            } else if (row.cardfrom == '2') {
                deduction = Math.round(amount * 0.07 * 100) / 100;
            }

            if (row.cardfrom == '1' || row.cardfrom == '2' || row.cardfrom == '7') {
                owneramount = "￥"+ (Math.round((amount - pointsamount - deduction ) * 100) / 100);
            } else if (row.cardfrom == '0'){
                owneramount = "￥"+ (amount - pointsamount)
            }

            return owneramount
        }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
</style>
